import React from 'react';

export function FormPartSelect (props) {
    let {formPart, saveFunction, lang, errors, hasError, register} = props;
    return (
        <div className={'form-group'}>
            <label htmlFor={'select-'+formPart.id} className={''}>{formPart.label}</label>
            <select
                className={formPart.required ? 'form-control requiredField ': 'form-control ' }
                name={'select-'+formPart.id} required={formPart.required}
                onChange={(event) => saveFunction(event, formPart.id, 'select')}
                ref={ register({ required: formPart.required, pattern: '/^\\S+@\\S+$/i'})}>
                <option disabled={formPart.required} value={''} selected >
                    {formPart.placeholder}
                </option>
                {
                    formPart.options.map((option) =>{
                        return !option.hidden && <option value={option.id}>{option.label}</option>;
                    })
                }
            </select>
            {
                hasError('select-'+formPart.id, errors) ? (<span className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', lang)}</span>) : ''
            }
        </div>
    );
}
